export default "__VITE_ASSET__8aeef8f9__"